import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SearchService {
  private apiUrl = 'https://www.googleapis.com/customsearch/v1';
  private youtubeApiUrl = 'https://www.googleapis.com/youtube/v3/search';
  private apiKey='AIzaSyBdse-KRHQdw0xsKUG9VPMa9JEM4DbUKns';
  private cx='d42f0fd42e89e495b'
  constructor(private http: HttpClient) { }

  searchImages(query: string): Observable<any> {
    const params = new HttpParams().set('key', this.apiKey).set('cx', this.cx).set('q', query).set('searchType', 'image').set('num', '10');
    return this.http.get<any>(this.apiUrl, { params });
  }

  searchVideos(query: string): Observable<any> {
    const params = new HttpParams().set('key', this.apiKey).set('q', query).set('part', 'snippet').set('type', 'video').set('maxResults', '10').set('videoDuration', 'medium').set('videoEmbeddable',true);
    return this.http.get<any>(this.youtubeApiUrl, { params });
  }
}
